import { useMemo } from "react";
import { useHasOrgContext } from "../../../common/auth/useHasOrgContext";
import type { WizardStepPath as StepPath } from "../../../common/wizard/wizardStepPaths";
import { urls } from "../../../urls";
import type { BidStep } from "./bid/bidWizardSteps";
import type { RequestStep } from "./request/requestWizardSteps";

export interface PortalEventUrls {
  list: string;
  view: {
    go: (eventId: string) => string;
    question: (eventId: string, questionId: string) => string;
    announcement: (eventId: string, announcementId: string) => string;
  };
  bid: { edit: { go: (eventId: string, bidId: string) => Record<BidStep, StepPath> } };
  privateBid: { edit: { go: (eventId: string, bidId: string) => string } };
  request: { edit: { go: (eventId: string, requestId: string) => Record<RequestStep, StepPath> } };
}

export const usePortalEventUrls = (): PortalEventUrls => {
  const hasOrgContext = useHasOrgContext();
  return useMemo(
    () =>
      hasOrgContext
        ? {
            list: urls.v2.supplier.procurements,
            view: urls.v2.supplier.procurement,
            bid: urls.v2.supplier.bid,
            privateBid: urls.v2.supplier.privateBid,
            request: urls.v2.supplier.request,
          }
        : {
            list: urls.portal.list,
            view: urls.portal.view,
            bid: urls.portal.bid,
            privateBid: urls.portal.privateBid,
            request: urls.portal.request,
          },
    [hasOrgContext],
  );
};
